import { SelectField } from '@flos/react-ui';
import type { DogClub_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import type { AttributeChangeProps } from '../../../types';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';

export const dogClubOptions: Array<{ label: string; value: DogClub_Top }> = [
    {
        label: 'Nej',
        value: 'NoDogClub'
    },
    {
        label: 'DKs civile hundeforening',
        value: 'DKsCivileHundeforening'
    },
    {
        label: 'Hjemmeværnet',
        value: 'Hjemmevaernet'
    },
    {
        label: 'Dansk Politihundeforening',
        value: 'DanskPolitihundeforening'
    },
    {
        label: 'Specialklubber under DKK',
        value: 'SpecialklubberUnderDKK'
    }
];

const DogClubChange = ({ updateCoverableAttribute }: AttributeChangeProps): JSX.Element => {
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const getHippoText = useHippoText();
    return (
        <>
            <h6>{getHippoText('DSS-PET-OPC-EDIT-DOG-CLUB-SELECT')}</h6>
            <SelectField
                iconShape="search"
                label="Vælg hundeklub"
                options={dogClubOptions}
                onChange={(e) => {
                    const selectedIndex = e.target.selectedIndex;
                    const { value } = e.target.options[selectedIndex];
                    updateCoverableAttribute({ club: value as DogClub_Top });
                    setIsOpcDataFilled(true);
                }}
                disabled={isOpcFetching}
            ></SelectField>
        </>
    );
};

export default DogClubChange;
